import { components, useApi } from "@appretio/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidateCubeMutation } from "./cubeMutationInvalidation";

type SetMainCubeInput = components["schemas"]["SetMainCubeInput"];

/**
 * Mutation hook that makes a user cube its owner's main version.
 * The server unsets any other main, so the whole versions surface is
 * invalidated to refresh the main markers.
 */
export function useSetMainCube() {
  const apiClient = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (input: SetMainCubeInput) => {
      const response = await apiClient.POST("/v2/forecast/cubes/set-main", {
        body: input
      });
      if (!response.data?.result) {
        throw new Error("Missing result in set-main response");
      }
      return response.data.result;
    },
    onSuccess: async () => {
      await invalidateCubeMutation(queryClient, { versions: true });
    },
    meta: {
      errorMessage: "Failed to set the main version"
    }
  });
}
